@if (dataLayerType.icon) {
  <app-svg-icon [key]="dataLayerType.icon"></app-svg-icon>
} @else {
  <i *ngIf="!dataLayerType.icon" class="fa-regular fa-map mr-2"></i>
}
<span>{{ dataLayerType.name }}</span>
